import React from 'react';

const NotFound = () => {
    return (
        <div>
            <img src="https://cdn.dribbble.com/users/1169343/screenshots/7044451/media/040703a1d4d3c2da683361bd9ba42e0a.png" width="100%" height="510px" alt="" />
        </div>


    );
};

export default NotFound;